import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const TipoContrato = () => {
  const [list1, setList1] = useState([]);
  const urlendpoint =
    "https://contratosback.azurewebsites.net/api/v1/ObtieneTipoContrato";

  useEffect(() => {
    obtenerContratos();
  }, []);

  const obtenerContratos = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((response) => {
        setList1(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const actualizaEstado = (id) => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      method: "put",
      url: `https://contratosback.azurewebsites.net/api/v1/ActualizaEstadoContrato/${id}`,
    })
      .then(() => {
        obtenerContratos();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const confirmarCambioEstado = (id, estadoActual, tipoContrato) => {
    const accion = estadoActual ? "inactivar" : "activar";

    Swal.fire({
      title: "¿Está seguro?",
      text: `Está a punto de ${accion} el contrato "${tipoContrato}"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: estadoActual ? "#d33" : "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        actualizaEstado(id);
        Swal.fire(
          "¡Hecho!",
          `El contrato "${tipoContrato}" fue ${accion} correctamente.`,
          "success",
        );
      }
    });
  };

  const visualizarContrato = (tipoContrato, minuta) => {
    Swal.fire({
      title: tipoContrato,
      html: minuta, // Renderiza el HTML que viene desde la API
      width: "80%",
      showCloseButton: true,
      showConfirmButton: false,
    });
  };

  const CrearContrato = (e) => {
    e.preventDefault();
    window.location.href = "/CreaTipoContrato";
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Contratos</h3>
              </CardHeader>
              <div className="text-center">
                <button
                  className="btn btn-success btn-lg"
                  onClick={CrearContrato}
                >
                  Crear un nuevo contrato
                </button>
              </div>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Tipo Contrato</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {list1.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.tipoContrato}</td>
                      <td>
                        {item.estado ? (
                          <Badge color="success">Activo</Badge>
                        ) : (
                          <Badge color="danger">Inactivo</Badge>
                        )}
                      </td>
                      <td>
                        <button
                          className={`btn btn-sm ${
                            item.estado ? "btn-danger" : "btn-success"
                          }`}
                          onClick={() =>
                            confirmarCambioEstado(
                              item.id,
                              item.estado,
                              item.tipoContrato,
                            )
                          }
                        >
                          {item.estado ? "Inactivar" : "Activar"}
                        </button>{" "}
                        <button
                          className="btn btn-info btn-sm"
                          onClick={() =>
                            visualizarContrato(item.tipoContrato, item.minuta)
                          }
                        >
                          Visualizar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <PaginationItem className="disabled">
                      <PaginationLink href="#pablo" tabIndex="-1">
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink href="#pablo">1</PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default TipoContrato;
